import { render, staticRenderFns } from "./application-view-date.vue?vue&type=template&id=bb56fad2&"
import script from "./application-view-date.vue?vue&type=script&lang=js&"
export * from "./application-view-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports